import { createPortal } from "react-dom";
import { useEffect, useId, useRef } from "react";
import { LuX } from "react-icons/lu";
export const TpvDialog = ({
  title,
  headerLeading = null,
  subtitle = null,
  headerTrailing = null,
  onClose,
  busy = false,
  children,
  className = "",
}) => {
  const ref = useRef(null),
    closeRef = useRef(onClose),
    busyRef = useRef(busy),
    id = useId();
  closeRef.current = onClose;
  busyRef.current = busy;
  useEffect(() => {
    const previous = document.activeElement;
    ref.current?.querySelector("button,input,select")?.focus();
    const handle = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        if (!busyRef.current) closeRef.current();
      }
      if (e.key === "Tab") {
        const controls = [
          ...ref.current.querySelectorAll(
            'button,input,select,textarea,[tabindex="0"]',
          ),
        ].filter((el) => !el.disabled && el.getClientRects().length);
        const first = controls[0],
          last = controls[controls.length - 1];
        if (!ref.current.contains(document.activeElement)) {
          e.preventDefault();
          first?.focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last?.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first?.focus();
        }
      }
    };
    const node = ref.current;
    node.addEventListener("keydown", handle);
    return () => {
      node.removeEventListener("keydown", handle);
      previous?.focus();
    };
  }, []);
  useEffect(() => {
    if (!busy && ref.current && !ref.current.contains(document.activeElement)) {
      ref.current
        .querySelector(
          "button:not(:disabled),input:not(:disabled),select:not(:disabled)",
        )
        ?.focus();
    }
  }, [busy]);
  return createPortal(
    <div className="tpvDialogOverlay">
      <section
        ref={ref}
        className={`tpvDialog ${className}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={id}
        aria-busy={busy}
      >
        <header>
          {headerLeading}
          {subtitle ? <div className="tpvDialogHeading"><h2 id={id}>{title}</h2><p>{subtitle}</p></div> : <h2 id={id}>{title}</h2>}
          {headerTrailing}
          <button
            type="button"
            aria-label={`Cerrar ${title}`}
            disabled={busy}
            onClick={onClose}
          >
            <LuX aria-hidden="true" />
          </button>
        </header>
        {children}
      </section>
    </div>,
    document.querySelector(".tpvWorkspace") || document.body,
  );
};
